class ChatKeepToken {
    constructor() {
        this.intervalTime = 600 * 1000;
        this.isStop = true;
        this.vue = undefined;
    }

    start(vue) {
        if (!this.isStop) {
            return;
        }
        
        this.isStop = false;
        this.vue = vue;
        this.check();
    }

    stop() {
        this.isStop = true;
    }

    async check() {
        if (this.isStop) {
            return;
        } else if (!this.vue) {
            return;
        }

        let isTriggerPing = false;
        let now = new Date();
        let rooms = this.vue.$store.state.chat.rooms;
        for (let i = 0; i < rooms.length; i++) {
            let room = rooms[i];
            if (room.messageSendTime) {
                let diff = now - room.messageSendTime;
                if (diff < this.intervalTime) {
                    isTriggerPing = true;
                    break;
                }
            }
        }

        try
        {
            if (isTriggerPing) {
                await $.postJSON('/api/Chat/Ping');
            }
        } catch (error) {
            console.error("chat send ping failed, error=" + error);
        }
        setTimeout(() => this.check(), this.intervalTime);
    }
}

export default new ChatKeepToken();